






















































import { Vue, Component, Mixins, Ref, Watch, Prop } from 'vue-property-decorator'
import BuilderNavigationStep from '@/components/builder/BuilderNavigationStep.vue'
import BuilderSidebar from '@/components/builder/BuilderSidebar.vue'
import { Location } from 'vue-router'
import BuilderDeviceChatStub, { CmpChannel } from '@/components/builder/BuilderDeviceChatStub.vue'
import BuilderDefaultContainer from '@/components/builder/BuilderDefaultContainer.vue'
import WithBuilderStubProperties from '@/mixins/WithBuilderStubProperties'
import { LocaleMessage } from 'vue-i18n'
interface Navigation {
  label: string | LocaleMessage
  to: Location
  checked: boolean
  show: boolean
}

export interface ChatStubState {
  title: string | null | LocaleMessage
  headerIcon: string | null
  highlight: string | null
  channels: CmpChannel[]
  create?: boolean
}

@Component({
  components: {
    BuilderDeviceChatStub,
    BuilderDefaultContainer,
    BuilderSidebar,
    BuilderNavigationStep,
  },
})
export default class BuilderChat extends Mixins(WithBuilderStubProperties) {
  @Ref('handler') handler!: Vue & {
    onStubStateReady?: () => Promise<void>
    onChannelLock?: (channel: CmpChannel, index: number) => void
    onChannelDelete?: (channel: CmpChannel, index: number) => void
  }

  @Prop({ default: false, type: Boolean }) loaded!: boolean

  stubState: ChatStubState = {
    title: this.$t('chats'),
    highlight: null,
    headerIcon: null,
    channels: [],
  }

  stepNumber = 0

  get formattedChannels(): CmpChannel[] {
    return this.stubState.channels
  }
  get currentIndex(): number {
    for (let i = 0; i < this.navigation.length; i += 1) {
      if (this.navigation[i].to.name === this.$route.name) {
        this.stepNumber = i + 1
        return i
      }
    }

    this.stepNumber = 1
    return 0
  }

  get navigation(): Navigation[] {
    const currentRoute = (this.$router as any).history?.current?.name
    const navigation = [
      {
        label: this.$t('createGeneralChat'),
        to: { name: 'chat.public' },
        checked: !!this.stubChannelsSource[0]?.name,
        show: true,
      },
      {
        label: this.$t('generalChatAvatar'),
        to: { name: 'chat.public_avatar' },
        checked: !!this.stubChannelsSource[0]?.image?.url,
        show: true,
      },
      {
        label: this.$t('createPersonalChat'),
        to: { name: 'chat.personal' },
        checked: !!this.stubChannelsSource[1]?.name,
        show: !!this.stubChannelsSource[0]?.image?.url || this.stepNumber !== 2,
      },
      {
        label: this.$t('personalChatAvatar'),
        to: { name: 'chat.personal_avatar' },
        checked: !!this.stubChannelsSource[1]?.image?.url,
        show: !!this.stubChannelsSource[1]?.name || this.stepNumber > 3,
      },
      {
        label: this.$t('createPrivateChat'),
        to: { name: 'chat.private' },
        checked: !!this.stubChannelsSource[2]?.name,
        show: !!this.stubChannelsSource[2]?.name
      },
      {
        label: this.$t('privateChatAvatar'),
        to: { name: 'chat.private_avatar' },
        checked: !!this.stubChannelsSource[2]?.image?.url,
        show:
          !!this.stubChannels[2]?.name
      },
      {
        label: this.$t('privateChatCustomization'),
        to: { name: 'chat.private_settings' },
        checked: this.stepNumber > 7,
        show: !!this.stubChannelsSource[2]?.image?.url && this.stepNumber > 6,
      },
      {
        label: this.$t('possibilities'),
        to: { name: 'chat.capabilities' },
        checked: currentRoute !== 'chat.capabilities',
        show: this.stepNumber > 7,
      },
      {
        label: this.$t('deleteChatsAndChannels'),
        to: { name: 'chat.delete_channels' },
        checked: currentRoute !== 'chat.capabilities' && currentRoute !== 'chat.delete_channels',
        show: this.stepNumber > 8,
      },
      {
        label: this.$t('createChatsAndChannels'),
        to: { name: 'chat.create_channels' },
        checked: currentRoute !== 'chat.create_channels',
        show: this.stepNumber > 9,
      },
    ]

    return navigation.map((n) => ({
      ...n,
      to: { ...n.to, params: { id: this.$route.params.id } },
    }))
  }

  @Watch('loaded', { immediate: true })
  async onLoadedChange(value: boolean): Promise<void> {
    this.dropStubState()

    if (value) {
      await this.notifyStubStateReady()
    }
  }

  @Watch('$route', { deep: true })
  async onRouteChange(): Promise<void> {
    this.dropStubState()
    await this.notifyStubStateReady()
  }

  async notifyStubStateReady(): Promise<void> {
    this.$nextTick(async () => {
      if (this.handler?.onStubStateReady) {
        await this.handler.onStubStateReady()
      }
    })
  }
  // @Watch('stubChannelsSource', { immediate: true, deep: true })
  // async onStubChannelsSourceChange(value: CmpChannel[]): Promise<void> {
  //   console.log(value)
  // }

  dropStubState(): void {
    this.stubState = {
      title: null,
      highlight: null,
      headerIcon: null,
      channels: this.stubChannels,
    }
  }

  onChatLock(channel: CmpChannel, index: number): void {
    if (this.handler.onChannelLock) {
      this.handler.onChannelLock(channel, index)
    }
  }

  onChatDelete(channel: CmpChannel, index: number): void {
    if (this.handler.onChannelDelete) {
      this.handler.onChannelDelete(channel, index)
    }
  }

  async onBack(): Promise<void> {
    this.dropStubState()

    if (this.currentIndex > 0) {
      await this.$router.push(this.navigation[this.currentIndex - 1].to)
    }
  }

  async onNext(): Promise<void> {
    this.dropStubState()
    if (this.currentIndex < this.navigation.length - 1) {
      await this.$router.push(this.navigation[this.currentIndex + 1].to)

      return
    }

    await this.$router.push({
      name: 'chat-created',
      params: { id: this.$route.params.id },
    })
  }
}
